import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import AuthProvider from './services/Context/Auth/provider';
import InfoProvider from './services/Context/Info/provider';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <InfoProvider>
        <App />
      </InfoProvider>
    </AuthProvider>
  </React.StrictMode>
);
